import { render } from "./questionDetail.vue?vue&type=template&id=c7859ea0&scoped=true"
import script from "./questionDetail.vue?vue&type=script&lang=js"
export * from "./questionDetail.vue?vue&type=script&lang=js"

import "./questionDetail.vue?vue&type=style&index=0&id=c7859ea0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7859ea0"]])

export default __exports__